import { Menu, MenuItem } from '@mui/material';
import React from 'react';
import { COUNTRY_INFO, toggleLanguage } from '../utils/languageHelper';
import { UserResponse } from '@services/authApi';
import { Locale } from 'types/locale';

interface LanguageDropDownMenuProps {
  anchorEl: HTMLElement;
  user: UserResponse;
  locale: Locale;
  setLocale: (value: React.SetStateAction<Locale>) => void;
  closeLanguageMenu: () => void;
}

const LanguageDropDownMenu: React.FC<LanguageDropDownMenuProps> = ({
  anchorEl,
  user,
  locale,
  setLocale,
  closeLanguageMenu,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={closeLanguageMenu}
    >
      {Object.keys(COUNTRY_INFO).map((lang) => (
        <MenuItem
          key={lang}
          onClick={() =>
            toggleLanguage(user, locale, setLocale, closeLanguageMenu, lang)
          }
        >
          <img
            src={COUNTRY_INFO[lang]?.flag}
            alt={COUNTRY_INFO[lang]?.displayName}
            width="20"
            height="20"
            style={{ marginRight: '8px' }}
          />
          {COUNTRY_INFO[lang]?.displayName}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default LanguageDropDownMenu;
